import {
  BasePageModel,
  basePageToLocal
} from '@interface/index';

export interface GenericType extends BasePageModel {
}

export const DefaultGenericTypes: GenericType[] = [{
  id: 'genericidt',
  name: 'T'
}];

export function genericTypeToLocal(data: any): GenericType {

  return {
    ...basePageToLocal(data)
  };
}

export function genericTypesToLocal(data: any): GenericType[] {

  const ret: GenericType[] = [];

  let fountT = false;

  if (data) {
    for (const t of data) {
      ret.push(genericTypeToLocal(t));
      if (t.name === 'T') {
        fountT = true;
      }
    }
  }

  if (!fountT) {
    ret.push(...DefaultGenericTypes);
  }

  return ret;
}

export function genericTypeToServer(data: GenericType) {
  return {
    name: data.name,
    inherited_from_composite_id: data.inheritedFromCompositeId
  };
}
